
const { EndPoints } = require("settings/endpoints");
const { default: axiosInstance } = require("./axios");


export const UpdatePasswordForFranchise = (payload) => {
    return axiosInstance.post(EndPoints.RESET_PASSWORD.FRANCHISE_UPDATE, payload)
}

export const UpdatePasswordForEmployee = (payload) => {
    return axiosInstance.post(EndPoints.RESET_PASSWORD.EMPLOYEE_UPDATE, payload)
}
